<section class="rule-details" aria-labelledby="rule-details-heading">
  <div class="section-heading">
    <h2 id="rule-details-heading">Rule Details</h2>
    <p>Define the rule eligibility criteria. All offer sets that meet the criteria will be impacted by the rule.</p>
  </div>

  <form [formGroup]="ruleDetailsForm" novalidate>
    <div class="form-grid">
      <div class="form-field">
        <label for="rule-type">Rule Type</label>
        <select id="rule-type" formControlName="ruleType">
          @for (option of ruleTypeOptions; track option.value) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>

      <div class="form-field">
        <label for="rule-privacy">Rule Privacy</label>
        <select id="rule-privacy" formControlName="privacy">
          @for (option of privacyOptions; track option.value) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>

      <div class="form-field toggle-field">
        <input id="rule-status" type="checkbox" formControlName="status">
        <label for="rule-status">Rule is active</label>
      </div>

      <div class="form-field">
        <label for="vehicle-type">Vehicle Type</label>
        <select id="vehicle-type" formControlName="vehicleType">
          @for (option of vehicleTypeOptions; track option.value) {
            <option [ngValue]="option.value">{{ option.label }}</option>
          }
        </select>
      </div>

      <div class="form-field">
        <label for="rule-year">Year</label>
        <input id="rule-year" type="number" inputmode="numeric" formControlName="year" min="1">
        @if (ruleDetailsForm.controls.year.invalid && ruleDetailsForm.controls.year.touched) {
          <span class="field-error">Year is required and must be a positive whole number.</span>
        }
      </div>

      <div class="form-field">
        <label for="rule-make">Make</label>
        <select id="rule-make" formControlName="make">
          <option [ngValue]="null">Select make</option>
          @for (make of facets.makes; track make) {
            <option [ngValue]="make">{{ make }}</option>
          }
        </select>
        @if (ruleDetailsForm.controls.make.invalid && ruleDetailsForm.controls.make.touched) {
          <span class="field-error">Make is required.</span>
        }
      </div>

      <div class="form-field">
        <label for="rule-model">Model</label>
        <select id="rule-model" formControlName="model">
          <option [ngValue]="null">Select model</option>
          @for (model of facets.models; track model) {
            <option [ngValue]="model">{{ model }}</option>
          }
        </select>
        @if (ruleDetailsForm.controls.model.invalid && ruleDetailsForm.controls.model.touched) {
          <span class="field-error">Model is required.</span>
        }
      </div>

      <div class="form-field">
        <label for="rule-trim">Trim</label>
        <select id="rule-trim" formControlName="trim">
          <option [ngValue]="anyTrimValue">Any</option>
          @for (trim of facets.trims; track trim) {
            <option [ngValue]="trim">{{ trim }}</option>
          }
        </select>
        @if (ruleDetailsForm.controls.trim.value === anyTrimValue) {
          <span class="field-warning">This rule will apply to all trims unless specified</span>
        }
        @if (ruleDetailsForm.controls.trim.invalid && ruleDetailsForm.controls.trim.touched) {
          <span class="field-error">Trim is required.</span>
        }
      </div>

      <div class="form-field">
        <label for="maximum-price">Maximum Price</label>
        <input id="maximum-price" type="number" inputmode="decimal" formControlName="maximumPrice" min="0" step="0.01">
        @if (ruleDetailsForm.controls.maximumPrice.invalid && ruleDetailsForm.controls.maximumPrice.touched) {
          <span class="field-error">Maximum Price is required and must be a finite non-negative number.</span>
        }
      </div>

      <div class="form-field">
        <label for="vehicle-limit">Vehicle Limit</label>
        <input id="vehicle-limit" type="number" inputmode="numeric" formControlName="vehicleLimit" min="0" step="1">
        @if (ruleDetailsForm.controls.vehicleLimit.invalid && ruleDetailsForm.controls.vehicleLimit.touched) {
          <span class="field-error">Vehicle Limit must be a non-negative whole number.</span>
        }
      </div>

      @if (!isOfferSetRule()) {
        <div class="form-field">
          <label for="dollar-discount">Dollar Discount Amount</label>
          <input id="dollar-discount" type="number" inputmode="decimal" formControlName="dollarDiscount" min="0.01" step="0.01">
          @if (ruleDetailsForm.controls.dollarDiscount.invalid && ruleDetailsForm.controls.dollarDiscount.touched) {
            <span class="field-error">Dollar Discount Amount must be greater than zero.</span>
          }
        </div>
      }

    </div>
  </form>

  @if (canDiscover()) {
    <auto-ipop-rule-workflow-qualifying-vehicles
      [discoveryState]="discoveryState"
      [selectedSource]="selectedSource"
      [selectionEnabled]="isOfferSetRule() && !isEditMode"
      [pageSize]="pageSize"
      [maximumPriceSortDirection]="maximumPriceSortDirection"
      (sourceSelected)="onSourceSelected($event)"
      (pageChanged)="onPageChanged($event)"
      (maximumPriceSortDirectionChanged)="onMaximumPriceSortDirectionChanged($event)"
      (retryRequested)="onRetryRequested()">
    </auto-ipop-rule-workflow-qualifying-vehicles>
  } @else {
    <div class="discovery-validation" role="alert">
      <strong>Qualifying Vehicles are unavailable.</strong>
      <span>Provide a valid account and correct invalid Year or Maximum Price values to discover vehicles.</span>
    </div>
  }
</section>
